import { render } from "./Created.vue?vue&type=template&id=56c2e6fa&scoped=true&ts=true"
import script from "./Created.vue?vue&type=script&lang=ts"
export * from "./Created.vue?vue&type=script&lang=ts"

import "./Created.vue?vue&type=style&index=0&id=56c2e6fa&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c2e6fa"]])

export default __exports__